import { render, staticRenderFns } from "./DeleteAddonDomainModal.vue?vue&type=template&id=731da2d0&"
import script from "./DeleteAddonDomainModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAddonDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731da2d0')) {
      api.createRecord('731da2d0', component.options)
    } else {
      api.reload('731da2d0', component.options)
    }
    module.hot.accept("./DeleteAddonDomainModal.vue?vue&type=template&id=731da2d0&", function () {
      api.rerender('731da2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/AddonDomains/DeleteAddonDomainModal.vue"
export default component.exports